import React, { useContext, useState } from 'react';
import { FaRegCopy, FaMicrophone } from 'react-icons/fa';
import { ReactComponent as ThumbsUp } from '../assets/images/thumbsUp.svg';
import { ReactComponent as ThumbsDown } from '../assets/images/thumbsDown.svg';
import posthog from 'posthog-js';

const ReactionBar = ({
  likes,
  handleLike: handleLikeParent,
  messageId,
  messageContent,
}) => {
  const darkMode = false;

  const handleLike = () => {
    const newValue = likes > 0 ? likes - 1 : 1;
    handleLikeParent(messageId, newValue);
    posthog.capture('message_reaction_submitted', {
      reaction: newValue > 0 ? 'like' : 'unlike',
      message_id: messageId,
    });
  };

  const handleDislike = () => {
    const newValue = likes < 0 ? likes + 1 : -1;
    handleLikeParent(messageId, newValue);
    posthog.capture('message_reaction_submitted', {
      reaction: newValue < 0 ? 'dislike' : 'undislike',
      message_id: messageId,
    });
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(messageContent)
      .then(() => alert('Copied to clipboard!'))
      .catch(() => alert('Failed to copy!'));
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        fontSize: '20px',
      }}
    >
      <button
        onClick={handleCopy}
        style={darkMode ? darkButtonStyle : buttonStyle}
      >
        <FaRegCopy />
      </button>
      <button
        onClick={handleLike}
        style={darkMode ? darkButtonStyle : buttonStyle}
      >
        <ThumbsUp /> {likes > 0 ? '1' : '0'}
      </button>
      <button
        onClick={handleDislike}
        style={darkMode ? darkButtonStyle : buttonStyle}
      >
        <ThumbsDown /> {likes < 0 ? '1' : '0'}
      </button>
    </div>
  );
};

const buttonStyle = {
  background: 'none',
  border: 'none',
  color: '#909090',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
};

const darkButtonStyle = {
  background: 'none',
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
};

export default ReactionBar;
